export default {
  id: 126,
  title: 'Target #126 - Letter A',
  url: 'https://cssbattle.dev/play/126',
  colors: ['#62306D', '#FEF9CA', '#C5B732', '#E38F66', '#AA445F'],
  solution:
    '<a a><a b><a c><a d><style>[a],[c]{top:80;width:42;height:140}[b],[d]{top:170;width:52;height:50}body{background:#62306d}a{position:fixed}[a]{left:209;transform:skew(20deg);background:#c5b732}[b]{left:198;transform:skew(40deg);background:#aa445f}[c]{left:149;transform:skew(-20deg);background:#fef9ca}[d]{left:150;transform:skew(-40deg);background:#e38f66}</style>',
}
